import BodyScrollMixin from 'trunks/vue/share/mixins/body_scroll.js';

const ModalMixin = {
  mixins: [BodyScrollMixin],

  data: function() {
    return {
      opened: true
    };
  },

  watch: {
    opened: function(newValue) {
      this.$emit('openedChange', newValue);
    }
  },

  mounted: function() {
    if (this.opened) {
      this.__enableBackdrop();
    }
  },

  computed: {
    bodyCanScroll: function() {
      return !this.opened;
    },

    statusClass: function() {
      return {
        'open': this.opened
      };
    },

    modalSize: function() {
      if (this.size) {
        return `${this.size}-modal`;
      }
    }
  },

  methods: {
    ensure: function() {
      this.close();
      this.$emit('ensureClicked', this);
    },

    cancel: function() {
      this.close();
      this.$emit('cancelClicked', this);
    },

    close: function() {
      this.opened = false;
      Skylark.Helpers.App.removeCapturedBackdropByID(this.backdropID);
    },

    open: function() {
      if (this.opened) {
        return;
      }

      this.opened = true;
      this.__enableBackdrop();
    },

    animationEnd: function() {
      if (this.opened) {
        this.$emit('afterOpened');
      } else {
        this.$emit('afterClosed');
      }
    },

    __enableBackdrop: function() {
      this.backdropID = Skylark.Helpers.App.capturedBackdrop(() => {
        this.$emit('maskClicked', this);

        if (this.backdrop) {
          return { force_clean: false };
        } else {
          return this.close();
        }
      }, this.$refs.content);
    }
  }
};

export default ModalMixin;
